/* ============================================================
   DASHBOARD — RUPA LAMA  (/dashboard, suis v3.9 MATI)
   ============================================================
   Pasangan rupa v3.9 fail ini ialah DashboardV39View.jsx.
   Kedua-duanya berkongsi SATU otak — src/hooks/useDashboard.js —
   dan tiga seksyen yang belum direvamp (notis kata laluan,
   Produk Baru, footer) datang daripada DashboardSections.jsx.

   ⛔ Jangan tulis semula logik Firestore di dalam fail ini.
      Kalau sesuatu perlu dibetulkan, betulkan dalam hook itu
      supaya kedua-dua rupa dapat pembetulan yang sama.

   Yang tinggal khusus untuk fail ini hanyalah RUPA: banner
   aurora bergerak + kad group sokongan hijau. Itu sahaja yang
   berbeza daripada rupa v3.9 buat masa ini.
   ============================================================ */

import React, { useState } from 'react';
import CampaignCalendarSection from './CampaignCalendarSection';
import { useDashboard, bolehLihatProdukBaru } from '../hooks/useDashboard';
import { PasswordSetupNotice, NewProductsSection, DashboardFooter } from './DashboardSections';

const GettingStartedView = ({ spaces = [], user, products = [], onSelectSpace, onGoToWorkspace, isPaid = false }) => {
    const d = useDashboard(user, { isPaid });
    const adminProdukBaru = bolehLihatProdukBaru(user);

    // Butang pensel hanya muncul bila tetikus di atas wish — rupa lama sahaja.
    const [wishHovered, setWishHovered] = useState(false);

    return (
        <div className="flex-1 overflow-y-auto flex flex-col bg-slate-50 dark:bg-slate-950" style={{ fontFamily: "'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

            {/* 2026-10-29 (arahan user): popup "Selamat datang ke SESAAT!" (TutorialModal) dibuang. Video tutorial kekal di menu Tutorial (/tutorial) dan halaman Extension. */}

            {/* ═══════════════ NOTIS: TETAPKAN KATA LALUAN (akaun Google sahaja) ═══════════════ */}
            <PasswordSetupNotice show={d.needsPasswordSetup} />

            {/* ═══════════════ WELCOME BANNER + GROUP SOKONGAN — 2 grid ═══════════════ */}
            {user && (
                <section className="w-full px-4 sm:px-6 pt-4 pb-2">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">
                    <div className="wb-banner">
                        {/* Aurora blobs */}
                        <div className="wb-aurora">
                            <div className="wb-aurora-blob wb-aurora-1"></div>
                            <div className="wb-aurora-blob wb-aurora-2"></div>
                            <div className="wb-aurora-blob wb-aurora-3"></div>
                            <div className="wb-aurora-blob wb-aurora-4"></div>
                            <div className="wb-aurora-blob wb-aurora-5"></div>
                        </div>

                        <div className="wb-content">
                            <div className="wb-text">
                                <p className="wb-greeting">{d.greeting}!</p>
                                <h2 className="wb-name">{d.displayName}.</h2>

                                {/* Editable wish */}
                                <div
                                    className="wb-wish-wrap"
                                    onMouseEnter={() => setWishHovered(true)}
                                    onMouseLeave={() => setWishHovered(false)}
                                >
                                    {d.isEditingWish ? (
                                        <div className="wb-wish-edit-row">
                                            <input
                                                ref={d.wishInputRef}
                                                className="wb-wish-input"
                                                value={d.wishDraft}
                                                onChange={e => d.setWishDraft(e.target.value)}
                                                onKeyDown={d.onWishKeyDown}
                                                maxLength={80}
                                                autoFocus
                                            />
                                            <button className="wb-wish-save-btn" onClick={d.saveWish} disabled={d.savingWish}>
                                                {d.savingWish
                                                    ? <span className="wb-wish-spinner" />
                                                    : <span className="material-symbols-outlined" style={{ fontSize: 15 }}>check</span>
                                                }
                                            </button>
                                            <button className="wb-wish-cancel-btn" onClick={d.cancelEditWish}>
                                                <span className="material-symbols-outlined" style={{ fontSize: 15 }}>close</span>
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="wb-wish-row">
                                            <p className="wb-wish">{d.wish}</p>
                                            {wishHovered && (
                                                <button className="wb-wish-edit-btn" onClick={d.startEditWish} title="Edit">
                                                    <span className="material-symbols-outlined" style={{ fontSize: 13 }}>edit</span>
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ─── Kotak kedua: group sokongan (link ejen yang merujuk, fallback group rasmi) ─── */}
                    <div className="wb-support">
                        <div className="wb-support-top">
                            <div className="wb-support-icon">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="wb-support-title">Group Support</h3>
                                <p className="wb-support-desc">Ada masalah atau nak tanya? Team support tolong anda terus dalam group WhatsApp.</p>
                            </div>
                        </div>
                        <a href={d.supportLink} target="_blank" rel="noopener noreferrer" className="wb-support-btn">
                            Sertai Group WhatsApp
                            <span className="material-symbols-outlined" style={{ fontSize: 16 }}>arrow_forward</span>
                        </a>
                    </div>
                  </div>

                    <style>{`
                        .wb-support {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            gap: 20px;
                            height: 100%;
                            border-radius: 20px;
                            padding: 28px 30px;
                            background: linear-gradient(135deg, #064e3b, #047857 55%, #059669);
                            box-shadow: 0 20px 60px rgba(5, 150, 105, 0.22);
                        }
                        .wb-support-top { display: flex; align-items: flex-start; gap: 14px; }
                        .wb-support-icon {
                            flex-shrink: 0;
                            width: 44px; height: 44px;
                            border-radius: 14px;
                            display: flex; align-items: center; justify-content: center;
                            background: rgba(255,255,255,0.14);
                            border: 1px solid rgba(255,255,255,0.2);
                            color: #ffffff;
                        }
                        .wb-support-title {
                            color: #ffffff;
                            font-size: 18px;
                            font-weight: 800;
                            margin-bottom: 4px;
                        }
                        .wb-support-desc {
                            color: rgba(209, 250, 229, 0.85);
                            font-size: 13px;
                            line-height: 1.6;
                        }
                        .wb-support-btn {
                            align-self: flex-start;
                            display: inline-flex;
                            align-items: center;
                            gap: 8px;
                            padding: 11px 20px;
                            border-radius: 14px;
                            background: rgba(255,255,255,0.95);
                            color: #047857;
                            font-size: 13px;
                            font-weight: 700;
                            text-decoration: none;
                            transition: all 0.2s ease;
                        }
                        .wb-support-btn:hover {
                            background: #ffffff;
                            transform: translateY(-1px);
                            box-shadow: 0 8px 20px rgba(0,0,0,0.18);
                        }
                        .wb-support-btn:active { transform: scale(0.97); }
                        @media (max-width: 640px) {
                            .wb-support { padding: 22px 20px; }
                        }
                        .wb-banner {
                            position: relative;
                            overflow: hidden;
                            height: 100%;
                            border-radius: 20px;
                            background: linear-gradient(-45deg, #053d4e, #0c7a8a, #2dd4bf, #0ea5e9, #064e5e, #0d9488);
                            background-size: 400% 400%;
                            animation: wbAuroraBase 10s ease infinite;
                            padding: 32px 36px;
                            box-shadow: 0 20px 60px rgba(14, 165, 233, 0.3);
                        }
                        @keyframes wbAuroraBase {
                            0%   { background-position: 0% 50%; }
                            25%  { background-position: 100% 0%; }
                            50%  { background-position: 100% 100%; }
                            75%  { background-position: 0% 100%; }
                            100% { background-position: 0% 50%; }
                        }

                        /* Floating glow orbs — visible on small banner */
                        .wb-aurora {
                            position: absolute;
                            inset: 0;
                            pointer-events: none;
                            overflow: hidden;
                        }
                        .wb-aurora-blob { position: absolute; border-radius: 50%; }

                        /* Orb 1 — bright white/cyan, top-left */
                        .wb-aurora-1 {
                            width: 320px; height: 320px;
                            background: radial-gradient(circle, rgba(255,255,255,0.35) 0%, rgba(103,232,249,0.5) 35%, transparent 70%);
                            top: -160px; left: -60px;
                            filter: blur(30px);
                            animation: wbOrb1 9s ease-in-out infinite;
                        }
                        /* Orb 2 — teal, right side */
                        .wb-aurora-2 {
                            width: 280px; height: 280px;
                            background: radial-gradient(circle, rgba(45,212,191,0.7) 0%, rgba(20,184,166,0.4) 45%, transparent 70%);
                            top: -100px; right: 80px;
                            filter: blur(25px);
                            animation: wbOrb2 11s ease-in-out infinite;
                        }
                        /* Orb 3 — pure white shimmer, center */
                        .wb-aurora-3 {
                            width: 180px; height: 180px;
                            background: radial-gradient(circle, rgba(255,255,255,0.4) 0%, transparent 65%);
                            top: -60px; left: 38%;
                            filter: blur(20px);
                            animation: wbOrb3 6s ease-in-out infinite;
                        }
                        /* Orb 4 — sky blue, bottom right */
                        .wb-aurora-4 {
                            width: 260px; height: 260px;
                            background: radial-gradient(circle, rgba(56,189,248,0.55) 0%, rgba(14,165,233,0.3) 45%, transparent 70%);
                            bottom: -140px; right: -30px;
                            filter: blur(28px);
                            animation: wbOrb4 13s ease-in-out infinite;
                        }
                        /* Orb 5 — indigo accent, bottom-left */
                        .wb-aurora-5 {
                            width: 220px; height: 220px;
                            background: radial-gradient(circle, rgba(129,140,248,0.45) 0%, rgba(99,102,241,0.2) 50%, transparent 70%);
                            bottom: -110px; left: 25%;
                            filter: blur(22px);
                            animation: wbOrb5 8s ease-in-out infinite;
                        }

                        @keyframes wbOrb1 {
                            0%, 100% { transform: translate(0px, 0px) scale(1); }
                            33%      { transform: translate(80px, 40px) scale(1.15); }
                            66%      { transform: translate(30px, -20px) scale(0.9); }
                        }
                        @keyframes wbOrb2 {
                            0%, 100% { transform: translate(0px, 0px) scale(1); }
                            40%      { transform: translate(-70px, 50px) scale(1.12); }
                            75%      { transform: translate(40px, -35px) scale(0.92); }
                        }
                        @keyframes wbOrb3 {
                            0%, 100% { transform: translate(0px, 0px) scale(1); opacity: 0.7; }
                            50%      { transform: translate(-40px, 30px) scale(1.25); opacity: 1; }
                        }
                        @keyframes wbOrb4 {
                            0%, 100% { transform: translate(0px, 0px) scale(1); }
                            30%      { transform: translate(-60px, -40px) scale(1.1); }
                            65%      { transform: translate(25px, 25px) scale(0.88); }
                        }
                        @keyframes wbOrb5 {
                            0%, 100% { transform: translate(0px, 0px) scale(1); opacity: 0.6; }
                            45%      { transform: translate(50px, -30px) scale(1.2); opacity: 0.9; }
                        }

                        .wb-content {
                            position: relative;
                            z-index: 10;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 24px;
                            flex-wrap: wrap;
                        }
                        .wb-text { flex: 1; min-width: 0; }
                        .wb-greeting {
                            color: rgba(207, 250, 254, 0.9);
                            font-size: 13px;
                            font-weight: 500;
                            margin-bottom: 4px;
                        }
                        .wb-name {
                            color: #ffffff;
                            font-size: 26px;
                            font-weight: 800;
                            letter-spacing: -0.5px;
                            line-height: 1.2;
                            margin: 0 0 6px;
                            text-shadow: 0 2px 12px rgba(0,0,0,0.15);
                        }

                        /* Wish */
                        .wb-wish-wrap { display: inline-block; }
                        .wb-wish-row {
                            display: flex;
                            align-items: center;
                            gap: 6px;
                        }
                        .wb-wish {
                            font-size: 15px;
                            font-weight: 500;
                            color: rgba(207,250,254,0.8);
                            margin: 0;
                            font-style: italic;
                        }
                        .wb-wish-edit-btn {
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            width: 20px; height: 20px;
                            border-radius: 6px;
                            background: rgba(255,255,255,0.15);
                            border: none;
                            color: rgba(255,255,255,0.8);
                            cursor: pointer;
                            transition: background 0.15s;
                            flex-shrink: 0;
                        }
                        .wb-wish-edit-btn:hover { background: rgba(255,255,255,0.25); }

                        .wb-wish-edit-row {
                            display: flex;
                            align-items: center;
                            gap: 4px;
                        }
                        .wb-wish-input {
                            background: rgba(0,0,0,0.3);
                            border: 1px solid rgba(255,255,255,0.3);
                            border-radius: 8px;
                            color: #ffffff;
                            font-size: 15px;
                            font-style: italic;
                            padding: 5px 10px;
                            outline: none;
                            width: 300px;
                            max-width: 100%;
                            font-family: inherit;
                        }
                        .wb-wish-input:focus { border-color: rgba(255,255,255,0.6); }
                        .wb-wish-save-btn, .wb-wish-cancel-btn {
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            width: 24px; height: 24px;
                            border-radius: 6px;
                            border: none;
                            cursor: pointer;
                            color: #fff;
                            flex-shrink: 0;
                            transition: all 0.15s;
                        }
                        .wb-wish-save-btn { background: rgba(16,185,129,0.7); }
                        .wb-wish-save-btn:hover { background: rgba(16,185,129,0.9); }
                        .wb-wish-cancel-btn { background: rgba(255,255,255,0.15); }
                        .wb-wish-cancel-btn:hover { background: rgba(255,255,255,0.25); }
                        .wb-wish-spinner {
                            width: 12px; height: 12px;
                            border: 2px solid rgba(255,255,255,0.3);
                            border-top-color: white;
                            border-radius: 50%;
                            animation: wbSpin 0.6s linear infinite;
                            display: inline-block;
                        }
                        @keyframes wbSpin { to { transform: rotate(360deg); } }

                        /* ═══ MOBILE ═══
                           Banner asal padding 32/36px + nama 26px — pada telefon
                           375px itu meninggalkan lebih kurang 300px untuk teks,
                           jadi nama pengguna yang panjang pecah tiga baris dan
                           butang group tersepit. Dikecilkan berkadar. */
                        @media (max-width: 640px) {
                            .wb-banner { padding: 22px 18px; border-radius: 16px; }
                            .wb-content { gap: 14px; }
                            .wb-name { font-size: 21px; }
                            .wb-greeting { font-size: 12px; }
                            .wb-wish { font-size: 13px; }
                            .wb-wish-input { width: 100%; font-size: 16px; }
                            .wb-wish-edit-row { flex-wrap: wrap; width: 100%; }
                            .wb-support { padding: 18px 16px; border-radius: 16px; }
                            .wb-support-title { font-size: 15px; }
                            .wb-support-desc { font-size: 12px; }
                            .wb-support-btn { width: 100%; justify-content: center; }
                            /* Orb hiasan dikecilkan — pada skrin kecil ia menjadi
                               kabus penuh yang menenggelamkan teks. */
                            .wb-aurora-1 { width: 200px; height: 200px; }
                            .wb-aurora-2 { width: 170px; height: 170px; }
                            .wb-aurora-3 { width: 120px; height: 120px; }
                            .wb-aurora-4 { width: 160px; height: 160px; }
                            .wb-aurora-5 { width: 140px; height: 140px; }
                        }
                    `}</style>
                </section>
            )}

            {/* ═══════════════ NEW PRODUCTS SECTION — ADMIN SAHAJA ═══════════════ */}
            {/* Disorok daripada pelanggan (arahan user 2026-08-21). Ini pagar KEDUA;
                pagar pertama dalam useDashboard.js melangkau bacaan Firestore —
                lihat nota pada bolehLihatProdukBaru() sebelum mengubah mana-mana satu. */}
            {adminProdukBaru && <NewProductsSection products={d.latestProducts} />}

            {/* ═══════════════ KALENDAR KEMPEN ═══════════════ */}
            {/* Kempen platform + cuti dijana dari formula (src/data/campaignCalendar.js),
                jadi seksyen ini tidak boleh jadi kosong walaupun Firestore gagal dibaca. */}
            <CampaignCalendarSection />

            {/* ═══════════════ FOOTER ═══════════════ */}
            <DashboardFooter />
        </div>
    );
};

export default GettingStartedView;
